import { environment } from "./../../../environments/environment.prod";
import { MqttService } from "./../../services/mqtt.service";
import { Chart } from "chart.js";
import { Component, OnInit, Input } from "@angular/core";
import * as moment from "moment";

@Component({
  selector: "app-game-bot",
  templateUrl: "./game-bot.component.html",
  styleUrls: ["./game-bot.component.scss"],
})
export class GameBotComponent implements OnInit {
  apList: Array<any> = [];
  difference: any;
  timestampList: Array<any> = [];
  liveChart: any;
  mqttService: any;
  meterId: any;
  buttonEnable: boolean = false;
  lastActivePower: any;
  lastPredicate: any;
  points = 0;
  counter = 0;
  constructor() {}

  ngOnInit(): void {
    this.meterId = localStorage.getItem("selected_meter");
    setTimeout(() => {
      this.graph();
      this.startDataCollection();
    }, 500);
  }

  startDataCollection() {
    if (this.mqttService) {
      this.mqttService.close();
      this.mqttService = null;
      this.counter = 0;
    }
    this.mqttService = new MqttService(environment.mqtt_host, [this.meterId]);

    this.mqttService.listen().subscribe((data) => {
      console.log(data);
      
      if (data.a == this.lastActivePower && this.lastPredicate == "eq") {
        this.points++;
      }
      if (data.a > this.lastActivePower && this.lastPredicate == "gt") {
        this.points++;
      }
      if (data.a < this.lastActivePower && this.lastPredicate == "lt") {
        this.points++;
      }
      this.lastPredicate = "Na";

      this.lastActivePower = data.a;
      this.counter++;
      console.log(this.counter);

      this.apList.push(data.a);
      let ts = moment(data.t * 1000).format("LT");
      this.timestampList.push(ts);
      this.liveChart.update();
      this.buttonEnable = false;
      if (this.counter === 6) {
        this.mqttService = null;
        if (this.mqttService) this.mqttService.close();
      }
    });
  }

  ngOnDestroy() {
    if (this.mqttService) this.mqttService.close();
  }

  graph() {
    var ctx = document.getElementById("myChart");
    this.liveChart = new Chart(ctx, {
      // The type of chart we want to create
      type: "line",

      // The data for our dataset
      data: {
        labels: this.timestampList,
        // labels: this.counter,
        datasets: [
          {
            data: this.apList,
            backgroundColor: "#EE2F53",
            borderColor: "#EE2F53",
            borderWidth: 1,
            fill: false,
            pointRadius: 0,
          },
        ],
      },

      // Configuration options go here
      options: {
        showToolTips: false,
        tooltipEvents: ["mousemove", "touchstart", "touchmove"],

        tooltip: {
          enabled: true,
        },

        responsive: true,
        legend: {
          display: false,
        },
        scales: {
          xAxes: [
            {
              barThickness: 10,
              gridLines: {
                display: false,
              },
            },
          ],
          yAxes: [
            {
              ticks: {
                display: true,
              },
            },
          ],
        },
      },
    });
  }

  predicate(predication: string) {
    this.buttonEnable = true;
    this.lastPredicate = predication;
    console.log(this.lastPredicate);
  }
}
